import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const useTuileSimplifie = () => {

  const { trackEvent } = useInteractionDoneTracking();

  const isSimplifie = useCookie("affichage-simplifie", {
    maxAge: 60 * 60 * 24 * 30 * 12
  });

  const setSimplifie = () => {
    isSimplifie.value = !isSimplifie.value;
    trackEvent({
      categoryGA: trackingCodes.CATEGORYGA.AfficherMoinsDinformations,
      actionGA: isSimplifie.value ? "Activé" : "Désactivé"
    })
  };

  return {
    isSimplifie,
    setSimplifie
  }
}